import { createV2Configuration } from './helpers';

import * as MNSproCloudV2 from './v2';
// The version of the OpenAPI document: 20220225.2

const V2 = { ...MNSproCloudV2, createConfiguration: createV2Configuration };

export { V2 };
